<template>
  <div class="product-list">
    <!-- 技师列表 -->
    <div class="table-wrap">
      <el-table :data="tableData" style="width: 100%" v-loading="loading">
        <el-table-column prop="name" label="技师姓名" width="120"></el-table-column>
        <el-table-column prop="image_url" label="照片" width="110">
          <template slot-scope="scope">
            <img v-img-url="'image.file_path',scope.row" width="80" height="80" />
          </template>
        </el-table-column>
        <el-table-column label="排班信息" >
          <template #default="scope">
            <div class="schedule-info">
              <div v-if="scope.row.week_schedule && scope.row.week_schedule.length > 0">
                <div
                  v-for="schedule in getActiveSchedules(scope.row.week_schedule)"
                  :key="schedule.id"
                  class="schedule-item"
                >
                  <span class="day-name">{{ schedule.day_name }}:</span>
                  <span class="time-range">{{ schedule.start_time.substring(0,5) }}-{{ schedule.end_time.substring(0,5) }}</span>
                  <span v-if="schedule.break_start_time" class="break-time">
                    (休息: {{ schedule.break_start_time.substring(0,5) }}-{{ schedule.break_end_time.substring(0,5) }})
                  </span>
                </div>
              </div>
              <div v-else class="no-schedule">暂无排班</div>
            </div>
          </template>
        </el-table-column>
<!--        <el-table-column prop="remark" label="备注"></el-table-column>-->
        <el-table-column fixed="right" label="排班操作" width="220">
          <template #default="scope">
            <el-button @click="handleSchedule(scope.row)" type="text" size="small" v-auth="'/technician/schedule/edit'">设置排班</el-button>
            <el-button @click="handleLeaveManage(scope.row)" type="text" size="small" v-auth="'/technician/leave/index'">休假管理</el-button>
<!--            <el-button @click="handleLeave(scope.row)" type="text" size="small" v-auth="'/technician/leave/add'">添加休假</el-button>-->
            <el-button @click="handleOverride(scope.row)" type="text" size="small" v-auth="'/technician/scheduleOverride/index'">临时排班</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!--分页-->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
                     :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
                     :total="totalDataNumber">
      </el-pagination>
    </div>

    <!-- 设置排班弹窗 -->
    <Edit v-if="open_schedule" :open_schedule="open_schedule" :technician="currentTechnician" @closeDialog="closeDialog($event, 'schedule')"></Edit>
    <!-- 添加休假弹窗 -->
    <TechnicianLeave v-if="open_leave" :open_leave="open_leave" :technician="currentTechnician" @closeDialog="closeDialog($event, 'leave')"></TechnicianLeave>


  </div>
</template>

<script>
// 引入技师列表API
import ScheduleApi from '@/api/technician/schedule.js';
// 引入两个弹窗组件
import Edit from './Edit.vue';
import TechnicianLeave from './TechnicianLeave.vue';

export default {
  components: {
    Edit,
    TechnicianLeave
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*是否打开排班弹窗*/
      open_schedule: false,
      /*是否打开休假弹窗*/
      open_leave: false,

      /*当前操作的技师对象*/
      currentTechnician: {}
    };
  },
  created() {
    /*获取技师列表*/
    this.getData();
  },
  methods: {
    /**
     * 获取技师信息和排班列表数据
     */
    getData() {
      let self = this;
      let Params = {
        page: self.curPage,
        list_rows: self.pageSize
      };
      self.loading = true;
      ScheduleApi.technicianList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /**
     * 获取激活的排班信息
     */
    getActiveSchedules(schedules) {
      return schedules.filter(schedule => schedule.is_active === 1);
    },
    /**
     * 打开排班弹窗
     */
    handleSchedule(item) {
      this.currentTechnician = item;
      this.open_schedule = true;
    },
    /**
     * 打开休假弹窗
     */
    handleLeave(item) {
      this.currentTechnician = item;
      this.open_leave = true;
    },
    /**
     * 跳转到临时排班管理页面
     */
    handleOverride(item) {
      this.$router.push({
        path: '/technician/scheduleOverride/index',
        query: {
          technician_id: item.id,
          technician_name: item.name
        }
      });
    },
    /**
     * 跳转到休假管理页面
     */
    handleLeaveManage(item) {
      this.$router.push({
        path: '/technician/leave/index',
        query: {
          technician_id: item.id,
          technician_name: item.name
        }
      });
    },
    /**
     * 关闭弹窗
     */
    closeDialog(e, type) {
      if (type == 'schedule') {
        this.open_schedule = false;
      } else if (type == 'leave') {
        this.open_leave = false;
      }
      // 如果弹窗操作成功，刷新列表
      if (e.type === 'success') {
        this.getData(); // 刷新数据
      }
    },
    /**
     * 每页多少条
     */
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },
    /**
     * 翻页
     */
    handleCurrentChange(val) {
      this.curPage = val;
      this.getData();
    },
  }
};
</script>

<style scoped>
.schedule-info {
  line-height: 1.4;
}

.schedule-item {
  margin-bottom: 4px;
  /*font-size: 12px;*/
}

.day-name {
  color: #409EFF;
  font-weight: bold;
  margin-right: 4px;
}

.time-range {
  color: #333;
  margin-right: 4px;
}

.break-time {
  color: #E6A23C;
  /*font-size: 11px;*/
}

.no-schedule {
  color: #909399;
  /*font-size: 12px;*/
}
</style>



// WEBPACK FOOTER //
// src/views/technician/schedule/index.vue